export default __webpack_public_path__ + "static/media/colorblock.8a52cf58.mp4";